const formatCurrency = (
  amount,
  internationalCountryCode = "en-US",
  currency = "USD"
) => {
  const formatted = new Intl.NumberFormat(internationalCountryCode, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);

  return formatted;
};

export default formatCurrency;
